import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ILoginDto } from '@adex/shared/models/dto/login.dto'
import { FormControl, FormGroup } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { IGoogleLoginUrlResponse } from '../../models/google-auth.model'
import { urls } from '@adex/shared/network/urls'
import { catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { Store } from '@ngrx/store'
import { alertError } from '@adex/store/actions'


@Component({
  selector: 'adex-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
  public formGroup = new FormGroup({
    login: new FormControl(),
    password: new FormControl()
  })

  @Input() public loadingFormState: boolean
  @Output() public submitForm: EventEmitter<ILoginDto> = new EventEmitter()

  constructor(private httpClient: HttpClient, private activatedRoute: ActivatedRoute, private readonly store: Store) {
  }

  public googleUrlResponse$ = this.httpClient.get<IGoogleLoginUrlResponse>(`${urls.auth.googleAuthUrl}?redirect_uri=${window.location.origin}/auth/google`).pipe(
    catchError((err, caught) => (of(false)))
  )

  public onSubmit(): void {
    const { login, password } = this.formGroup.value

    if (!login || !password) return
    if (login.includes('@propellerads.net')) {
      this.store.dispatch(alertError({message: 'Use Google Auth button to authorize'}))

      return
    }

    this.submitForm.emit({ login, password })
  }

  public onGoogleClick(googleUrlResponse: IGoogleLoginUrlResponse) {
    if (googleUrlResponse) {
      window.location.href = googleUrlResponse.url
    }
  }

  public ngOnInit(): void {
    const userFromQueryParams = this.activatedRoute.snapshot.queryParamMap.get('user')

    if (userFromQueryParams?.length > 0) {
      window.localStorage.setItem('adex|userFromQueryParams', userFromQueryParams)
    }
  }
}
